import React, { useEffect, useState } from "react";
import SearchIcon from "../assets/search.svg";
import "./userController.css";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux-store/store";
import { GetAllUser } from "../../../api/ssoapi/UserControlapi";

import { showErrorNotification } from "../modal/Tostify";

import UserContorlTable from "./UserContorlTable";
import UserFilter from "./UserFilterPopup";
import {
  IUserFilterModel,
  UserControlSlices,
} from "../../../slices/UserControlSlice";
import { ESearchFilterActiveTypes } from "../../../constants/CommonInterfaces";
import { Pagination } from "antd";

const UserController: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const loader = useSelector(
    (state: RootState) => state.userControl.api.isLoading
  );

  const searchFilter = useSelector(
    (state: RootState) => state.userControl.searchFilter
  );
  const userSearchQuery = useSelector(
    (state: RootState) => state.userControl.searchFilter.apiQuery
  );
  const globalSearch = useSelector(
    (state: RootState) => state.userControl.searchFilter.globalSearch
  );
  const totalCount = useSelector(
    (state: RootState) => state.userControl.totalCount
  );
  const globalSearchApiQuery = useSelector(
    (state: RootState) => state.userControl.searchFilter.globalSearchApiQuery
  );
  const [isGlobalSearchActive, setIsGlobalSearchActive] =
    useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // api call function for getUser initial
  useEffect(() => {
    performGetNotifyData();
  }, [
    userSearchQuery.isPageChanged,
    userSearchQuery.isAscending,
    userSearchQuery.sortField,
  ]);

  const performGetNotifyData = () => {
    let lapiQuery = Object.assign({}, userSearchQuery);
    if (searchFilter.lastActiveSearch === ESearchFilterActiveTypes.global) {
      lapiQuery.filters = searchFilter.globalSearchApiQuery.filters;
      lapiQuery.isOr = searchFilter.globalSearchApiQuery.isOr;
    }

    dispatch(GetAllUser(lapiQuery));
  };
  // set the search query to search table content
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setIsGlobalSearchActive(false);
    dispatch(
      UserControlSlices.UpdateGlobalSearchFilter({
        value: e.target.value,
      })
    );
  };

  // global search will affect after press the enter key
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      performGlobalSearch();
    }
  };

  // global search will affect after press the enter key
  const handleClickGlobalSearch = (e: any) => {
    performGlobalSearch();
  };

  useEffect(() => {
    if (isGlobalSearchActive) {
      let lQuery: IUserFilterModel = {
        filters: searchFilter.globalSearchApiQuery.filters,
        isAscending: false,
        currentPageSize: searchFilter.apiQuery.currentPageSize,
        pageSize: searchFilter.apiQuery.pageSize,
        page: 1, //First time always get page 1
        isOr: true,
        isPageChanged: "",
        sortField: "",
      };
      dispatch(
        UserControlSlices.UpdateLastActiveSearch({
          value: ESearchFilterActiveTypes.global,
        })
      );
      dispatch(
        UserControlSlices.ResetColumnSearchFilter({
          canClearAll: true,
          fieldClear: "",
        })
      );
      dispatch(
        UserControlSlices.resetLocalSearchQuery({
          canClearAll: true,
          fieldClear: "",
        })
      );
      dispatch(GetAllUser(lQuery));
      setIsGlobalSearchActive(false);
    }
  }, [isGlobalSearchActive]);

  const performGlobalSearch = () => {
    dispatch(UserControlSlices.UpdateGlobalSearchFilterActive());
    dispatch(
      UserControlSlices.UpdateGlobalSearchApiQuery({
        value: globalSearch.value,
        needToSetActive: globalSearch.isActive,
      })
    );
    setIsGlobalSearchActive(true);
  };

  const paginationHandler = (page: number, pageSize: number) => {
    dispatch(
      UserControlSlices.UpdatePagination({
        page: page,
        pageSize: pageSize,
        isPageChanged: true,
      })
    );
  };

  // useEffect hook for loader action
  useEffect(() => {
    setIsLoading(loader);
  }, [loader]);

  return (
    <div className="notification-main-container">
      <div style={{ height: "calc(100% - 30px)" }}>
        <div className="main-heading-container">
          <div className="main-heading">User Control</div>
          <div style={{ display: "flex", gap: 10 }}>
            <div
              className={`search-container ${
                globalSearch.isActive ? " active-search-container" : ""
              }`}
            >
              <input
                type="search"
                placeholder="Search"
                value={globalSearch.value}
                className="input-element"
                autoComplete="off"
                onChange={(e) => handleSearchChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
              />
              <img
                src={SearchIcon}
                alt="search"
                className="search-icon"
                style={{ cursor: "pointer" }}
                onClick={handleClickGlobalSearch}
              />
            </div>
            <div className="filter-container">
              <UserFilter accessorKey="ExtensiveSearch" />
            </div>
          </div>
        </div>
        <div className="user-table-view-container">
          <UserContorlTable />
        </div>
      </div>
      <div className="pagination-container">
        <Pagination
          size="small"
          align="start"
          current={searchFilter.apiQuery.page}
          pageSize={searchFilter.apiQuery.pageSize}
          total={totalCount}
          onChange={paginationHandler}
          showSizeChanger={false}
        />

        <div className="label-element">{`Showing ${
          (searchFilter.apiQuery.page - 1) * searchFilter.apiQuery.pageSize + 1
        } to ${
          (searchFilter.apiQuery.page - 1) * searchFilter.apiQuery.pageSize +
          1 +
          (searchFilter.apiQuery.currentPageSize - 1)
        } of ${totalCount} entries`}</div>
      </div>
    </div>
  );
};

export default UserController;
